export default __webpack_public_path__ + "static/media/2Loop.4da61c08.mp4";